async function devtricker_ajax_post_recoverAccount(login, pow, pass, duration) {

    try {
        const formData = new FormData();

        formData.append('action', 'devtricker_action_send_password_reset_email_ajax');
        formData.append('user_login', login);
        formData.append('nonce', await devtricker_ajax_get_getDevtrickerRecoverNonce());
        formData.append('pow', pow);
        formData.append('pass', pass);
        formData.append('duration', duration);

        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        });


        const result = await response.json();

        if (result.success) {

            devtricker_log(null, devtricker_log_level.INFO, `Password reset request received for user: ${login}`);

            return result;

        } else {
            throw new Error(`Password recovery failed for user: ${login}`);
        }
    } catch (error) {

        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}

async function devtricker_ajax_post_reset_password_with_code(login, code, new_password) {

    try {
        const formData = new FormData();

        formData.append('action', 'devtricker_reset_password_with_code_ajax');
        formData.append('user_login', login);
        formData.append('reset_code', code);
        formData.append('new_password', new_password);

        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        });

        const result = await response.json();

        return result;

    } catch (error) {

        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}